// USER_CLICKED actions

// SYSTEM_action_process actions
export const SYSTEM_EMAIL_VERIFY_FAIL = 'acct/system/verify_email_fail';
